/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Sold-out state management for BIS (Back in Stock) button
  function setSoldOutState(isSoldOut) {
    document.querySelector('.bis-button')?.style.setProperty('display', isSoldOut ? 'block' : 'none');
    document.querySelector('.qty_submit__buttons')?.classList.toggle('is-sold-out', isSoldOut);
    document.querySelector('.pdp--buynowbutton')?.classList.toggle('d-none', isSoldOut);
  }

  function getInitialSoldOutState() {
    try {
      const product = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
      const variantId = document.querySelector('input[name="id"]')?.value;
      const variant = product.variants?.find(v => v.id == variantId) 
                   || product.variants?.find(v => v.available) 
                   || product.variants?.[0];
      return variant?.available === false;
    } catch { return false; }
  }

  document.addEventListener('theme:variant:change', e => e.detail.variant && setSoldOutState(!e.detail.variant.available));

  document.addEventListener('DOMContentLoaded', function() {
    const init = () => setSoldOutState(getInitialSoldOutState());
    if (document.querySelector('.bis-button')) return init();
    
    const observer = new MutationObserver(() => {
      if (document.querySelector('.bis-button')) { init(); observer.disconnect(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 5000);
  });

  document.addEventListener('theme:cart:change', function(event) {
    return;

    var cart = event.detail.cart;
    if (cart) {
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    return;
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

//Custom_ customizations
window.Custom_ = window.Custom_ || {};

window.Custom_.cartHandler = {
  
  LOW_PRICE_TIER: window.theme.settings.lower_threshold,
  HIGH_PRICE_TIER: window.theme.settings.higher_threshold,

  validateGiftItems: async function (items) {
    this.cleartype = "";

    this.nonGiftItems = items.filter(a=>!a.is250 && !a.is250over );
    this.GiftItems = items.filter(a=>a.is250s );
    this.GiftItemsUnder = this.GiftItems.filter(a=>a.is250);
    this.GiftItemsOver = this.GiftItems.filter(a=>a.is250over );
    this.GiftItemsWithExcessQuantities = this.GiftItems.filter(a=>parseInt(a.quantity)>1);
    this.GiftItemCount = this.GiftItems.length;
    const removeAllGiftItems = this.nonGiftItems.length == 0 && this.GiftItems.length > 0;
    const removeUnderGiftItems = this.GiftItemsUnder.length > 0 && this.eventDetails.total_price < this.LOW_PRICE_TIER;
    const removeOverGiftItems = this.GiftItemsOver.length > 0 && this.eventDetails.total_price < this.HIGH_PRICE_TIER;

    if (this.GiftItemCount > 1) {
      this.cleartype = 'has1';
    } else if(removeAllGiftItems){
      this.cleartype = "all";
    }else if(removeUnderGiftItems){
      this.cleartype = "under";
    }else if(removeOverGiftItems){
      this.cleartype = "over";
    }

    // console.log("validating",{clearType: this.cleartype, removeAllGiftItems, removeUnderGiftItems, removeOverGiftItems });

    if(removeAllGiftItems || removeUnderGiftItems || removeOverGiftItems || this.GiftItemCount > 1){
      await this.removeGiftItems();
    }else if(this.GiftItemsWithExcessQuantities.length > 0){
      await this.adjustGiftItems();
    }
    return items;

  },

  async removeGiftItems(){
    let builtRemovedata = {
      updates:{}
    };
    if ((this.cleartype === 'has1')) {
      const found = this.GiftItems.find((a) => a.is250s == true);
      builtRemovedata.updates[found.id] = 0;
	} else if (this.cleartype === 'all') {
		this.GiftItems.forEach((a) => {
			builtRemovedata.updates[a.id] = 0;
		});
	} else if (this.cleartype === 'under') {
		this.GiftItemsUnder.forEach((a) => {
			builtRemovedata.updates[a.id] = 0;
		});
	} else if (this.cleartype === 'over') {
		this.GiftItemsOver.forEach((a) => {
			builtRemovedata.updates[a.id] = 0;
		});
	}

    // console.log("removeGiftItems", builtRemovedata)

    const cart = await this.cartUpdate(builtRemovedata);
    this.refreshCart(cart);

  },
  async adjustGiftItems(){
    let builtRemovedata = {
      updates:{}
    };
    this.GiftItemsWithExcessQuantities.forEach(a=>{
      builtRemovedata.updates[a.id] = 1
    })
    // console.log("adjustGiftItems", builtRemovedata)
    const cart = await this.cartUpdate(builtRemovedata);
    this.refreshCart(cart);

  },

  refreshCart(cart=null){
    // document.dispatchEvent(new CustomEvent('theme:cart:init',{bubbles:true}));
    //added my custom cart detail to the event to force update the cart
    document.dispatchEvent(new CustomEvent('theme:cart:reload',{bubbles:true,detail:{cart: cart}}))
  },

  cartUpdate: async function(data){
    return window.fetch(`${window.theme.routes.cart}/update.js`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data),
    })
    .then(res=>res.json())
    .catch(err=> {
      // console.log("cartUpdate Error:", err)
      return null;
    })
  },

  handler: function(evt) {
    this.eventDetails = evt.detail.cart;
    this.eventDetailsIncrease = evt.detail?.isIncrease;
    // console.log("changed",evt.type);
    fetch('/cart?view=gift-checker')
    .then(res=>res.json())
    .then(this.validateGiftItems.bind(this))
    // .then(this.validateBundleItems.bind(this))
    // .then(this.validateBundleLonePairs.bind(this))
    .catch(err=>{})
  },


  init: function(){
    ['theme:cart:change'].forEach(function(type) {
      document.addEventListener(type, this.handler.bind(this));
      // document.addEventListener(type, this.productBundleHandler.bind(this));
    }.bind(this));
  }

}
window.Custom_.cartHandler.init();

//init mini modal
function initMiniModalImageSlider(){

  let newModalSliderFlick = document.querySelector('.img_custom_flickity_height');
  if(newModalSliderFlick.classList.contains("loaded")) return;
  var flkty = new themeVendor.Flickity(newModalSliderFlick, {
    autoPlay: false,
    prevNextButtons: true,
    contain: true,
    pageDots: false,
    adaptiveHeight: false,
    accessibility: true,
    wrapAround: false,
    fade: true,
    fullscreen: true,
    on: {
      ready: function() {
        newModalSliderFlick.classList.add("loaded");
        minimodalUpdatedImage(newModalSliderFlick);
      }
    }
  });
  // console.log("new flickity loadedd", newModalSliderFlick.classList);
}

//select minimodal updated image
function minimodalUpdatedImage(el){
  const parent = el.closest('.custom-modal-body'),
        form = parent?.querySelector('product-form');

  const currentState = form.productForm.getFormState();
  setTimeout(()=>{
    form.pushState(currentState);
    // form.updateProductImage(currentState);
    // console.log("form=>",currentState);
  },100)
}



// custom code - pdp
document.addEventListener('DOMContentLoaded', (e) => {
  const customMiniModal = document.querySelectorAll('#mini_modal_discount .modal-img-wrapper .product__media');

  // custom modal
  document.querySelectorAll('[data-modalcustom]').forEach(function(modal){
    modal.addEventListener('click', function(e){
      const target=e.currentTarget;
      const targetModal = modal.dataset.modalcustom;
      const modalM = document.getElementById(targetModal);
      const isBundleModalOpentrigger = target.classList.contains('bundle_atc');
      const isMiniBundleModalOpentrigger = target.classList.contains('minibundle__atc');

      if(isMiniBundleModalOpentrigger){
        setTimeout(initMiniModalImageSlider, 100);
      }

      modalM.classList.toggle('show');
      document.getElementsByTagName("BODY")[0].classList.toggle('overflow-hidden');

      if(isBundleModalOpentrigger) {
        setTimeout(function(){ initBundleModalSliders(modalM); }, 100);
        bundleVariantPriceEvaluator(modalM);
      }
    })
  });

  function initBundleModalSliders(modalEl) {
    const sliders = modalEl.querySelectorAll('.modal_img_slides:not(.flickity-enabled)');
    sliders.forEach(function(slider) {
      new themeVendor.Flickity(slider, {
        autoPlay: false,
        prevNextButtons: true,
        contain: true,
        pageDots: false,
        adaptiveHeight: false,
        accessibility: true,
        wrapAround: false,
        fade: true,
        fullscreen: true
      });
    });
  }

  function changeBundleATCstatus(btn, available){
    if(available){
      btn.removeAttribute("disabled");
      btn.querySelector('[data-add-to-cart-text]').innerHTML = 'ADD TO CART'
    }else{
      btn.setAttribute("disabled", true);
      btn.querySelector('[data-add-to-cart-text]').innerHTML = 'SOLD OUT'
    }
  }

  function bundleVariantPriceEvaluator(modalM, variant = null){
    const dataHolder = modalM.querySelector('bundle-json-data') || modalM.closest('.js-custom-modal-body').querySelector('bundle-json-data');
    if (!dataHolder) return;
    const totalPriceHolder = dataHolder.parentElement.querySelector('.bundle_products_compare_price');
    const discountPriceHolder = dataHolder.parentElement.querySelector('.bundle_products_regular_price');
    const allforms = dataHolder.forms;
    const mainproductJson = dataHolder?.mainproductJson;
    const secondproductJson = dataHolder?.secondproductJson;

    if (!mainproductJson || !secondproductJson) return;

    const changedId = variant?.id;
    let currentvariantIds = [mainproductJson[0].id, secondproductJson[0].id];

    if(allforms.length >= 2){
      currentvariantIds[0] = allforms[0].id.value;
      currentvariantIds[1] = allforms[1].id.value;
    }

    const v1 = changedId ? mainproductJson.find(a=>a.id == parseInt(currentvariantIds[0])) : mainproductJson[0];
    const v2 = changedId ? secondproductJson.find(a=>a.id == parseInt(currentvariantIds[1])) : secondproductJson[0];

    if (!v1 || !v2) return;

    const v_available = v1?.available && v2?.available;

    const bundleATC = modalM?.closest('.js-custom-modal-body')?.querySelector('[js-bundle-atc]');
    bundleATC && changeBundleATCstatus(bundleATC, v_available);

    const metaDiscount = parseInt(dataHolder.metaDiscount) * 100;

    let mainVariantPrice = v1.c_price > v1.price ? v1.c_price : v1.price;
    let secondVariantPrice = v2.c_price > v2.price ? v2.c_price : v2.price;

    let totalPrice = mainVariantPrice + secondVariantPrice;
    let discountedPrice = totalPrice - metaDiscount;
    totalPriceHolder.innerHTML = themeVendor.themeCurrency.formatMoney(
      totalPrice,
      theme.moneyFormat
    );
    discountPriceHolder.innerHTML = themeVendor.themeCurrency.formatMoney(
      discountedPrice,
      theme.moneyFormat
    );
  }

  function bundleModalImageSwitcher(container, variant){
    if (!variant.featured_media || !variant.featured_media.id) return;

    const modalBody = container.closest('.js-custom-modal-body');
    if (!modalBody) return;

    const mediaId = parseInt(variant.featured_media.id);
    const productWrapper = container.closest('.modal_first_product') || container.closest('.modal_second_product');
    if (!productWrapper) return;

    const imgWrapper = productWrapper.querySelector('.modal-img-wrapper');
    if (!imgWrapper) return;

    const allMedia = imgWrapper.querySelectorAll('.product__media');
    const slider = imgWrapper.querySelector('.modal_img_slides');
    const flkty = slider && themeVendor.Flickity.data(slider);

    if (flkty) {
      const cells = flkty.cells;
      for (let i = 0; i < cells.length; i++) {
        if (parseInt(cells[i].element.dataset.mediaId) === mediaId) {
          flkty.select(i);
          break;
        }
      }
    } else {
      allMedia.forEach(function(item) {
        const itemMediaId = parseInt(item.dataset.mediaId);
        if (itemMediaId === mediaId) {
          item.classList.add('is-selected');
          item.style.display = '';
        } else {
          item.classList.remove('is-selected');
          item.style.display = 'none';
        }
      });
    }
  }

  function minimodalImageSwitcher(variant){
    if (!variant.featured_media || !variant.featured_media.id) return;

    customMiniModal.forEach(item => {
      const miniMediaDataInt = parseInt(item.dataset.mediaId);
      const miniMediaId = parseInt(variant.featured_media.id);

      if(miniMediaId === miniMediaDataInt) {
        const itemImg = item.querySelector(".lazy-image");
        const isSelected = document.querySelector('#mini_modal_discount .modal-img-wrapper .product__media.is-selected .lazy-image');
        if(isSelected && itemImg) isSelected.innerHTML = itemImg.innerHTML;
      }
    });
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      const isModal = container.classList.contains('modal');
      const isMiniModal = container.classList.contains('mini__modal');
      if (isModal) {
        bundleVariantPriceEvaluator(container, variant);
        bundleModalImageSwitcher(container, variant);
      }

      if (isMiniModal) {
        minimodalImageSwitcher(variant);
      }
    }
  });

  // change bundle quantity
  document.querySelectorAll('.first_qty').forEach(function(firstqty){
    firstqty.addEventListener('change', function(item){
      const qty = item.value;
      const selectorToChange = item.dataset.qtyselect;
      // document.getElementById(selectorToChange).value = qty;
      // console.log('ssfsf =>>>>>> ', document.getElementById(selectorToChange).value);
      // console.log('this =>>>>>> ', item.value);
    })
  });


  // trigger mini bundle
  const discountQtyPriceBtn = document.querySelectorAll('.discount_qty_price_btn');
  if(discountQtyPriceBtn) {
    discountQtyPriceBtn.forEach(function(btn){
      btn.addEventListener('click', function(){
        // console.log("data price")
        const dataQty = parseInt(btn.dataset.qty);
        const dataPrice = btn.dataset.price;
        const dataPriceMain = btn.dataset.mainprice;
        document.getElementById('mini_bundle_qty').value = dataQty;
        document.getElementById('bundle_price_change').innerHTML = dataPrice;
        const cmpareatpricesel = document.getElementById('bundle_price_change_compare')
        cmpareatpricesel.innerHTML = dataPriceMain;
        if(dataQty != 1){
          cmpareatpricesel.classList.remove('hide');
        }else{
          cmpareatpricesel.classList.add('hide');

        }
        
  
        // toggle active class
        discountQtyPriceBtn.forEach(function(item){
          item.classList.remove('active')
        });
        btn.classList.add('active');
      })              
    });


  }
});




document.addEventListener('theme:cart:change',function(e){
  return;
  // disabled for now
  const cartTotal= parseInt(e.detail?.cart?.total_price) || 0;
  const announcementEl = document.querySelectorAll('.announcement__wrapper');
  // const announcementEl = document.getElementById('shopify-section-announcement');
  if(cartTotal >= 15000){
    announcementEl.forEach(el=>el.classList.remove('hide'))
  }else{
    announcementEl.forEach(el=>el.classList.add('hide'))

  }
});


// chat widget functionality
(function(){

  function setCookie(cname, cvalue, min) {
    const d = new Date();
    d.setTime(d.getTime() + (min * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function appendCrossBtn(iframe, isChatOpen) {
    // const iframe = document.querySelector("#dummy-chat-button-iframe");
    const iframeDoc = (iframe.contentWindow || iframe.contentDocument);
    const crossBtn = document.querySelector("#chat-cross-btn").cloneNode(true);
    crossBtn.style.cssText = `
      background: #000;left: 0px;visibility: visible;font-size: 19px;line-height: 19px;z-index: 9999;
    `;
    const badgeContainer =  iframeDoc.document.querySelector("[aria-label='Chat window']");
    if(!isChatOpen) {
      iframe.style.setProperty('display','block','important');
  
      badgeContainer.appendChild(crossBtn);
      crossBtn.addEventListener('click', function(e) {
        iframe.remove();
        // sessionStorage.setItem('hideChat',true);
        setCookie("_es_hidechat","true",10);
      });
    }else{
      iframe.remove();
      return;
    }
  
    // if(!isChatOpen) {
    badgeContainer.addEventListener('click', function() {
      setTimeout(function() {
        chatCrossBtn();
      }, 500);
    });
    // }
    
  }
  
  function chatCrossBtn() {
    const hideSession = getCookie('_es_hidechat');
    const isChatOpen = hideSession ? true : false;
    const MAX_TIMES_TO_CHECK = 80; //appprox 10 min
    let counter = 0;
  
    // console.log(isChatOpen);
    var chatPopupDivChecking = setInterval(function() {
      counter++;
      // console.log(' FINDING... ');
      // Find it with a selector
      let iframeEl;
      if(document.querySelector("#dummy-chat-button-iframe")){
        iframeEl = document.querySelector("#dummy-chat-button-iframe");
        // console.log(iframeEl.id);
        if(iframeEl) appendCrossBtn(iframeEl, isChatOpen);
        clearInterval(chatPopupDivChecking);
      }
      if(document.querySelector("#shopify-chat")){
        // console.log(' CORRECT! ');
        iframeEl = document.querySelector("#ShopifyChat");
        appendCrossBtn(iframeEl, isChatOpen);
        clearInterval(chatPopupDivChecking);
      }
      if(counter > MAX_TIMES_TO_CHECK) clearInterval(chatPopupDivChecking);
    }, 500);
  }

  // Init chat widget button watcher
  document.addEventListener('DOMContentLoaded', (e) => {
    chatCrossBtn();
  })

})();

// Lazy-load sibling swatches on collection grids via IntersectionObserver
(function () {
  const containers = document.querySelectorAll('[data-siblings-collection]');
  if (!containers.length) return;

  const cache = {};

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadSiblings(entry.target);
      });
    },
    { rootMargin: '200px' }
  );

  containers.forEach(function (el) {
    observer.observe(el);
  });

  function getSizedUrl(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src.startsWith('//') ? 'https:' + src : src);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function renderSiblings(container, products) {
    var currentHandle = container.getAttribute('data-current-handle');
    var html = '';

    products.forEach(function (product) {
      var isCurrent = product.handle === currentHandle;
      var currentClass = isCurrent ? 'siblings__link--current' : '';
      var colorName = product.metafields?.theme?.cutline || escapeHtml(product.title);
      var imgSrc = product.featured_image
        ? getSizedUrl(product.featured_image.src, 100)
        : '';
      var imgStyle = imgSrc
        ? "background-image: url('" + imgSrc + "'); background-position: center top;"
        : '';

      html +=
        '<div class="siblings__link__holder">' +
        '<a href="/products/' + product.handle + '" class="siblings__link ' + currentClass + '" data-swapper-hover="' + colorName + '">' +
        '<div class="siblings__swatch">' +
        '<div class="sibling__image">' +
        '<div class="image__fill fade-in-child" style="padding-top: 100%;">' +
        '<div class="background-size-cover" style="' + imgStyle + '" role="img" aria-label="' + colorName + '"></div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</a>' +
        '</div>';
    });

    container.innerHTML = html;
    initScrollArrows(container);
  }

  function initScrollArrows(inner) {
    var prev = inner.parentNode.querySelector('[data-scrollbar-arrow-prev]');
    var next = inner.parentNode.querySelector('[data-scrollbar-arrow-next]');
    if (!prev || !next) return;

    function toggleArrows() {
      prev.classList.toggle('is-hidden', inner.scrollLeft <= 0);
      next.classList.toggle(
        'is-hidden',
        inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth - 1
      );
    }

    next.addEventListener('click', function (e) {
      e.preventDefault();
      inner.scrollBy({ left: inner.offsetWidth / 2, behavior: 'smooth' });
    });
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      inner.scrollBy({ left: -inner.offsetWidth / 2, behavior: 'smooth' });
    });

    inner.addEventListener('scroll', toggleArrows);
    toggleArrows();
  }

  function loadSiblings(container) {
    var collection = container.getAttribute('data-siblings-collection');
    if (!collection) return;

    if (cache[collection]) {
      renderSiblings(container, cache[collection]);
      return;
    }

    fetch('/collections/' + collection + '/products.json?limit=50')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.products || [];
        cache[collection] = products;
        renderSiblings(container, products);
      })
      .catch(function () {});
  }
})();

// observer to obser CURRENCY CHANGES PDP
(function(){
  const targetNode = document.querySelector('.js-price-observer');
  const config = { attributes: false, childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        const target = mutation.target;
        if(target.children.length == 0) target.textContent = target.textContent.split(" ")[0]
        // console.log('A child node has been added or removed.',mutation.target.innerText);
      }
    }
  };

  const observer = new MutationObserver(callback);
  if(targetNode) observer.observe(targetNode, config);

})()